import React from 'react';
import { Droppable } from '@hello-pangea/dnd';
import styled from 'styled-components';

import TileList from './TileList.jsx';

const StyledTileListContainer = styled.div``;
class DroppableColumn extends React.Component {
  render() {
    return (
      <Droppable droppableId={this.props.columnId} direction="horizontal">
        {provided => (
          <StyledTileListContainer
            ref={provided.innerRef}
            {...provided.droppableProps}
            showStats={this.props.showStats}
          >
            <TileList {...this.props} tiles={this.props.tiles} />
            {provided.placeholder}
          </StyledTileListContainer>
        )}
      </Droppable>
    );
  }
}

DroppableColumn.defaultProps = {
  showStats: false,
};

export { DroppableColumn };
